import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import { Icon, Loader } from '../../components';
import { Item, List, Overlay, Tag, Text } from './Nav.styled';

export default function Nav({ isNavOpen, onClose }) {
	const { pathname } = useLocation();
	const [loading, setLoading] = useState(false);

	const links = [
		{
			text: 'About',
			route: '/about',
		},
		{
			text: 'Blog',
			route: '/blog',
		},
	];

	useEffect(() => {
		if (!isNavOpen) {
			setLoading(false);
		}
	}, [loading, isNavOpen]);

	const handleSetLoading = () => {
		setTimeout(() => {
			setLoading(true);
		}, 100);
	};

	return (
		<Tag $isNavOpen={isNavOpen} aria-expanded={isNavOpen}>
			{isNavOpen && <Overlay onClick={onClose}></Overlay>}
			{loading ? (
				<Loader size="large" />
			) : (
				<List>
					{links.map((link, i) => (
						<Item key={i} onClick={handleSetLoading}>
							<Link
								to={link.route}
								className={
									pathname.includes(link.route)
										? 'active'
										: undefined
								}
							>
								<Text>
									<span>{link.text}</span>
								</Text>
							</Link>
						</Item>
					))}
					<Item>
						<a
							href="https://www.instagram.com/guitarlos/"
							target="_blank"
							rel="noopener noreferrer"
							className="instagram"
							id="instagram-nav-link"
							title="@guitarlos"
						>
							<Icon type="instagram" size="2rem" />
						</a>
					</Item>
				</List>
			)}
		</Tag>
	);
}
